import LabServiceModel from "@/models/LabServiceModel";
import ProjectModel from "@/models/lab/ProjectModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import TurnaroundModel from "@/models/lab/TurnaroundModel";
import SampleCollection from "@/collections/lab/SampleCollection";
import TestPackageModel from "./TestPackageModel";
import SubmissionStatusLogCollection from "@/collections/lab/SubmissionStatusLogCollection";

export default class SubmissionModel extends LabServiceModel {

  modelName() {
    return 'submission';
  }

  defaults() {
    return {
      id: null,
      pid: null,
      project_id: null,
      project: null,
      sample_type_id: null,
      sample_type: null,
      turnaround_id: null,
      turnaround: null,
      identifier: null,
      event_code: null,
      note: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      samples: {},
      submission_soil: null,
      submission_tissue: null,
      submission_status_logs: [],
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      pid: (val) => (this.nullStringMutator(val)),
      project_id: (val) => (this.nullStringMutator(val)),
      project: Object,
      sample_type_id: (val) => (this.nullStringMutator(val)),
      sample_type: Object,
      turnaround_id: (val) => (this.nullStringMutator(val)),
      turnaround: Object,
      identifier: (val) => (this.nullStringMutator(val)),
      event_code: (val) => (this.nullStringMutator(val)),
      note: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
      submission_soil: Object,
      submission_tissue: Object
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getProject() {
    return this.getRelatedModel(ProjectModel, 'project');
  }

  getTestPackage() {
    return this.getRelatedModel(TestPackageModel, 'test_package');
  }

  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }

  getTurnaround() {
    return this.getRelatedModel(TurnaroundModel, 'turnaround');
  }

  getSamples() {
    return this.getRelatedCollection(new SampleCollection(), 'samples');
  }

  getSubmissionStatusLogs() {
    return this.getRelatedCollection(new SubmissionStatusLogCollection(), 'submission_status_logs');
  }

  publicNumber() {
    return this.get('pid')
  }

}
